import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import { CONFIG, CONFIG_API_BE, URL_AKM} from '../../../../../config';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import { Row, Col, Alert,Modal } from 'react-bootstrap';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import accountManagement from '../../../../../apis/accountManagement';
import eduprimeApi from '../../../../../apis/eduprimeApi';
import akmApi from '../../../../../apis/akmApi';
import Select from 'react-select';


import ReactExport from "react-data-export";

import DropdownProvinsi from '../../masterDropDown/DropdownProvinsi';
import DropdownKota from '../../masterDropDown/DropdownKota';
import DropdownSekolahEntity from '../../masterDropDown/DropdownSekolahEntity';
import DropdownKelas from '../../masterDropDown/DropdownKelas';
import DropdownKelasParalel from '../../masterDropDown/DropdownKelasParalel';
import DropdownKurikulum from '../../masterDropDown/DropdownKurikulum';
import DropdownKodeJenjangSekolah from '../../masterDropDown/DropdownKodeJenjangSekolah';


class ImportSiswa extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            error: null,
            resMessage: '', 
            alertShow: false,          
            isFetching: false,
            openModalKelasParalel : false,
            openModalKelasParalel : false,
            file: '',
            listProvinsi : [],
            listKota : [],
            listSekolah : [],
            listKelas : [],
            listKelasParalel : [],
            dataSiswa : [],
            dataSekolah: [],
            dataKelasParalel: [],
            openModalDownload: false,
            isPsep: null,
            idKabKota: null,
            kodeJenjangSekolah : null,
            idSekolah : null,
            idKelas : null,
            idKelasParalel : null,
            idKurikulum : null
        }
        this.myRef = React.createRef()   // Create a ref object 
    }

    async componentDidMount(){
        console.clear();
        await this.props.cekCookies();
        if(!__.isEmpty(this.props.account)) {
            this.fetchProvinsi();
        }     
    }

    componentDidUpdate(){
        console.clear();
        console.log(this.state)
    }

    fetchProvinsi = async()=>{
        this.setState({isFetching:true})     
        const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_PROVINSI, {})
        if (respons) {
            if (!__.isEmpty(respons.data.list_provinsi)) {
                // this.setState({
                //     provinsi: respons.data.list_provinsi
                // })
                const dataProvinsi = {value : '', label: 'Pilih Provinsi...', id:'idProvinsi', isDisabled: true, isSelected: true}
                this.state.listProvinsi.push(dataProvinsi);
                respons.data.list_provinsi.map((val, i)=>{
                    const dataProvinsi = {value : val.ID_PROVINSI, label: val.NAMA_PROVINSI, id:'idProvinsi'}
                    this.state.listProvinsi.push(dataProvinsi);

                })
            }
        }
        this.setState({isFetching:false}) 
    }

    handleProvinsiOnChange = async (e)=>{
        const idProvinsi = e.target.value

        this.setState({
            isFetching:true,
            idProvinsi : e.target.value
        }) 

        const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA+idProvinsi, {})
        if (respons) {
            if (!__.isEmpty(respons.data.list_kab_kota)) {
                this.setState({
                    kota: respons.data.list_kab_kota
                })
            }
        }

        this.setState({isFetching:false})
    }

    handleKotaOnChange = async (e)=>{
        this.setState({ idKabKota: e.target.value });
    }

    onFileChange = (event) => {        
		this.setState({
			file: event.target.files[0]
		});
    }

    handleChangeUniversal = async (e)=>{
        let name = e.target.name;
        let val = e.target.value;

        this.setState({ 
            [name] : val,
            isFetching : true
        });

        if(name === 'kodeJenjangSekolah'){
            this.setState({
                listSekolah : [],
                listKelas : [],
                listKelasParalel : [],
            });
            
            if(this.state.idKabKota != null){
                // FETCH SEKOLAH
                let data = new FormData();
                
                data.append('idKabupatenKota', this.state.idKabKota);
                data.append('kodeJenjangSekolah', val);
                
                const response = await akmApi.post(URL_AKM.FETCH_SEKOLAH_BY_ID_KAB_AND_JENJANG,
                    data
                ).catch(function(error){
                    this.setState({error})
                })
                if(response.data.errorSchema.errorCode == URL_AKM.SUCCESS_ERROR_CODE){
                    const data = {value : '', label: 'Pilih Sekolah...', id:'idSekolah', selected: 'selected'}
                    this.state.listSekolah.push(data);
                    response.data.data.map((val, i)=>{
                        const data = {value : val.idSekolah, label: val.namaSekolah, id:'idSekolah'}
                        this.state.listSekolah.push(data);
                    })
                }
            }

            // FETCH KELAS BY KODE JENJANG
            const response = await akmApi.get(URL_AKM.GET_KELAS_BY_KODE_JENJANG+val
            ).catch(function(error){
                this.setState({error})
            })
            if(response){
                this.setState({ listKelas:  response.data.data});
            }
        }  

        // FETCH KELAS PARALEL
        if(name === "idKelas"){
            this.setState({
                listKelasParalel : [],
                idKelasParalel: ''
            });

            if(this.state.idSekolah != null){
                const response = await akmApi.post(URL_AKM.FETCH_KELAS_PARALEL_BY_ID_SEKOLAH_KELAS,
                    {
                        'idSekolah' : this.state.idSekolah,
                        'idKelas' : val
                    }
                ).catch(function(error){
                    this.setState({error})
                })
                if(response.data.errorSchema.errorCode == URL_AKM.SUCCESS_ERROR_CODE){
                    this.setState({ listKelasParalel:  response.data.data});
                }
            }
        }


        this.setState({ isFetching: false});
    }

    handleModal(newSekolah, newKelas){
        this.setState({ 
            'openModalSekolah' : newSekolah,
            'openModalKelasParalel' : newKelas 
        });
    }

    handleSubmitImport = async (e)=>{
        e.preventDefault();
        console.log(this.state);
        this.setState({ 
           isFetching : true 
        });

        let data = new FormData();
                
        data.append('idKabupatenKota', this.state.idKabKota);
        data.append('idSekolah', this.state.idSekolah);
        data.append('idKelas', this.state.idKelas);
        data.append('idKelasParalel', this.state.idKelasParalel);
        data.append('idKurikulum', this.state.idKurikulum);
        data.append('file', this.state.file);
        
        const response = await akmApi.post(URL_AKM.IMPORT_SISWA,
            data
        ).catch(function(error){
            this.setState({error})
        })
        if(response){
            window.scrollTo(0, 0);
            this.setState({ 
                openModalDownload: true,
                resMessage: response.data.errorSchema,
                isFetching: false,
                alertShow:true,
                dataSiswa: response.data.data.dataSiswa,
                keterangan: response.data.data.keterangan,
                dataSekolah: response.data.data.dataSekolah,
                dataKelasParalel: response.data.data.dataKelasParalel
            });
        }
    }

    resetState = async () =>{
        this.setState({ 
            openModalDownload: false,
            file : '',
            dataSiswa : [],
            alertShow:false
        });
    }

    handleChangeSelect = async e => {
        const name = e.id;
        const id = e.value;
        this.setState({ 
            [e.id]: id,
            isFetching : true
        });
        
        console.clear();
        console.log(this.state);
        console.log(name);
        console.log(id);
        
        if(name == 'idProvinsi'){
            this.setState({ listKota: [], listSekolah: [], listKelas: [], listKelasParalel: [], idKabKota: null });
            const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA+id, {})
            if (respons) {
                if (!__.isEmpty(respons.data.list_kab_kota)) {
                    // this.setState({
                    //     listKota: respons.data.list_kab_kota
                    // })

                    const data = {value : '', label: 'Pilih Kota...', id:'idKabKota', isDisabled: true, isSelected: true}
                    this.state.listKota.push(data);
                    respons.data.list_kab_kota.map((val, i )=>{
                        const data = {value : val.ID_KABUPATEN_KOTA, label: val.NAMA_KABUPATEN_KOTA, id:'idKabKota'}
                        this.state.listKota.push(data);
                    })
                }
            }
        }

        if(name == 'kodeJenjangSekolah' || name == 'idKabKota'){
            this.setState({
                listSekolah : [],
                listKelas : [],
                listKelasParalel : [],
            });
            
            if(this.state.idKabKota != null){
                // FETCH SEKOLAH
                let data = new FormData();

                if(name == 'kodeJenjangSekolah'){                
                    data.append('idKabupatenKota', this.state.idKabKota);
                    data.append('kodeJenjangSekolah', id);
                }else{    
                    data.append('idKabupatenKota', id);
                    data.append('kodeJenjangSekolah', this.state.kodeJenjangSekolah);                    
                }
                
                const response = await akmApi.post(URL_AKM.FETCH_SEKOLAH_BY_ID_KAB_AND_JENJANG,
                    data
                ).catch(function(error){
                    this.setState({error})
                })

                
                if(response.data.errorSchema.errorCode == URL_AKM.SUCCESS_ERROR_CODE){
                    const data = {value : '', label: 'Pilih Sekolah...', id:'idSekolah', isDisabled: true, isSelected: true}
                    this.state.listSekolah.push(data);
                    response.data.data.map((val, i)=>{
                        const data = {value : val.idSekolah, label: val.namaSekolah, id:'idSekolah'}
                        this.state.listSekolah.push(data);
                    })
                }
            }

            // FETCH KELAS BY KODE JENJANG
            const response = await akmApi.get(URL_AKM.GET_KELAS_BY_KODE_JENJANG+id
            ).catch(function(error){
                this.setState({error})
            })
            if(response.data.errorSchema.errorCode == URL_AKM.SUCCESS_ERROR_CODE){
                this.setState({ listKelas:  response.data.data});
            }

        }

        if(name == 'idSekolah'){
            
            this.setState({
                idKelas:'',
                listKelasParalel : [],
                idKelasParalel: ''
            });
            // FETCH KELAS BY KODE JENJANG
            const response = await akmApi.get(URL_AKM.GET_KELAS_BY_KODE_JENJANG+this.state.kodeJenjangSekolah
                ).catch(function(error){
                    this.setState({error})
                })
            if(response.data.errorSchema.errorCode == URL_AKM.SUCCESS_ERROR_CODE){
                this.setState({ listKelas:  response.data.data});
            }
        }

        this.setState({ isFetching : false });
    };

    render() {
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        const {error, isFetching, listProvinsi, listKota, idProvinsi, idKabKota, idSekolah, idKelas, idKelasParalel, idKurikulum, isPsep, dataSiswa,
                kodeJenjangSekolah, listSekolah, listKelas, listKelasParalel, dataSekolah, dataKelasParalel} = this.state;

        const listKodeJenjang = [
            { value : 'SD', label : 'SD', id:'kodeJenjangSekolah'},
            { value : 'SMP', label : 'SMP', id:'kodeJenjangSekolah'},
            { value : 'SMA', label : 'SMA', id:'kodeJenjangSekolah'},
            { value : 'SMK', label : 'SMK', id:'kodeJenjangSekolah'},
            { value : 'MI', label : 'MI', id:'kodeJenjangSekolah'},
            { value : 'MTs', label : 'MTs', id:'kodeJenjangSekolah'},
            { value : 'MA', label : 'MA', id:'kodeJenjangSekolah'}
        ]

        if(error){
            return (
                <div>Error: {error.message}</div>
              )
        } 
        return ( 
            <div className="wrapper">
            <LoaderModal isFetching={isFetching} />
            <Sidebar account={this.props.account}/>
            <div id="content" style={{paddingBottom: '50px'}}>
                <Navbar />  
                <div className="row">
                    <div className="col-md-12">
                        <h4>UPLOAD SISWA</h4>
                    </div>                         
                </div>
                {this.loadAlert()}   
                <div className="row">
                    <div className="col-md-5">
                        <div class="card">
                            <div class="card-body">
                                <form onSubmit={this.handleSubmitImport}>  

                                    {/* <div className="form-group">
                                        <label><span className="text-danger">*</span>Provinsi </label>
                                        <select className="form-control" name="idProvinsi" id="idProvinsi" 
                                            value={idProvinsi}
                                            onChange={this.handleProvinsiOnChange} required>
                                            <option value="" disabled selected>Pilih Provinsi...</option>
                                            <DropdownProvinsi provinsi={listProvinsi}/>
                                        </select>                                        
                                    </div>     
                                    
                                    <div className="form-group">
                                        <label><span className="text-danger">*</span>Kabupaten / Kota </label>
                                        <select className="form-control" name="idKota" id="idKota" 
                                            value={idKabKota}
                                            onChange={this.handleKotaOnChange} required>
                                            <option value="" disabled selected>Pilih Kota...</option>
                                            <DropdownKota kota={listKota}/>
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label><span className="text-danger">*</span>Jenjang Sekolah</label>
                                        <select className="form-control" name="kodeJenjangSekolah" id="kodeJenjangSekolah" 
                                            value={kodeJenangSekolah}
                                            onChange={this.handleChangeUniversal} required >
                                            <option value="" disabled selected>Pilih Kode Jenjang...</option>
                                            <DropdownKodeJenjangSekolah />
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label><span className="text-danger">*</span>Sekolah</label>
                                        {!__.isEmpty(listSekolah) && 
                                            <a href="#" style={{"float":"right", "color":"#001fff"}} title="Sekolah Baru" 
                                                onClick={() => this.handleModal(true, false)}>new</a>
                                        }
                                        <select className="form-control" name="idSekolah" id="idSekolah" 
                                            value={idSekolah}
                                            onChange={this.handleChangeUniversal} required>
                                            <option value="" selected>Pilih Sekolah...</option>
                                            <DropdownSekolahEntity sekolah={listSekolah}/>
                                        </select>
                                    </div>
                                    
                                    */}
                                    <Fragment>    
                                        <Select 
                                            options={listProvinsi}
                                            onChange={this.handleChangeSelect}
                                            placeholder ="Pilih Provinsi..."
                                        />
                                        <input
                                            tabIndex={-1}
                                            autoComplete="off"
                                            style={{ opacity: 0, height: 0 }}
                                            value={idProvinsi}
                                            required
                                        />
                                    </Fragment>

                                    <Fragment>    
                                        <Select 
                                            options={listKota}
                                            onChange={this.handleChangeSelect}
                                            placeholder ="Pilih Kabupaten / Kota..."
                                        />
                                        <input
                                            id="idKabKota"
                                            tabIndex={-1}
                                            autoComplete="off"
                                            style={{ opacity: 0, height: 0 }}
                                            value={idKabKota}
                                            required
                                        />
                                    </Fragment>

                                    <Fragment>    
                                        <Select 
                                            options={listKodeJenjang}
                                            onChange={this.handleChangeSelect}
                                            placeholder ="Pilih Kode Jenjang..."
                                        />
                                        <input
                                            tabIndex={-1}
                                            autoComplete="off"
                                            style={{ opacity: 0, height: 0 }}
                                            value={kodeJenjangSekolah}
                                            required
                                        />
                                    </Fragment>

                                    <Row>
                                        <Col>
                                            {!__.isEmpty(listSekolah) && 
                                                <a href="#" style={{"float":"right", "color":"#001fff"}} title="Sekolah Baru" 
                                                    onClick={() => this.handleModal(true, false)}>new</a>
                                            }
                                        </Col>
                                    </Row>

                                    <Fragment>    
                                        <Select 
                                            options={listSekolah}
                                            onChange={this.handleChangeSelect}
                                            placeholder ="Pilih Sekolah..."
                                        />
                                        <input
                                            tabIndex={-1}
                                            autoComplete="off"
                                            style={{ opacity: 0, height: 0 }}
                                            value={idSekolah}
                                            required
                                        />
                                    </Fragment>

                                    <div className="form-group">
                                        <label><span className="text-danger">*</span>Kelas</label> 
                                        <select className="form-control" name="idKelas" id="idKelas" 
                                            value={idKelas}
                                            onChange={this.handleChangeUniversal} required>
                                            <option value="" selected>Pilih Kelas...</option>
                                            <DropdownKelas kelas={listKelas}/>
                                        </select>
                                    </div> 

                                    <div className="form-group">
                                        <label><span className="text-danger">*</span>Kelas Paralel</label>
                                        { idKelas !=null && 
                                            <a href="#" style={{"float":"right", "color":"#001fff"}} title="Kelas Paralel Baru" 
                                            onClick={() => this.handleModal(false, true)}>new</a>
                                        }
                                        <select className="form-control" name="idKelasParalel" id="idKelasParalel" 
                                            value={idKelasParalel}
                                            onChange={this.handleChangeUniversal} required>
                                            <option value="" disabled selected>Pilih Kelas Paralel...</option>
                                            <DropdownKelasParalel kelasParalel={listKelasParalel}/>
                                        </select>
                                    </div>    

                                    <div className="form-group">
                                        <label><span className="text-danger">*</span>Kurikulum</label>
                                        <select className="form-control" name="idKurikulum" id="idKurikulum" 
                                            value={idKurikulum}
                                            onChange={this.handleChangeUniversal} required>
                                            <option value="" disabled selected>Pilih Kurikulum...</option>
                                            <DropdownKurikulum/>
                                        </select>
                                    </div>  

                                    <div className="form-group">
                                        <label><span className="text-danger">*</span>Pilih File: </label>
                                        <input type="file" className="form-control" required 
                                        onChange={this.onFileChange} id="file"
                                        accept=".xlsx" />
                                    </div>
                                    <br />
                                    <button type="submit" value="Submit" className="btn btn-primary">
                                        <li className="fa fa-upload"> Upload</li>
                                    </button>
                                    &nbsp;  
                                    {/* !__.isEmpty(dataSiswa) &&
                                        <ExcelFile element={<button className="btn btn-info" onClick={() => this.resetState}>Download Data</button>} filename= {dataSekolah.namaSekolah+"_"+dataKelasParalel.namaKelasParalel} >
                                            <ExcelSheet data={dataSiswa} name="Username Sekolah">
                                                <ExcelColumn label="Nama Siswa" value="namaSiswa"/>
                                                <ExcelColumn label="Username" value="usernameSiswa"/>
                                                <ExcelColumn label="Password" value="passwordSiswa"/>
                                            </ExcelSheet>

                                        </ExcelFile>
                                     */}
                                    
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div class="card">
                            <div class="card-body">
                                <h5>Prosedur Upload Siswa :</h5>
                                <ol>
                                    <li>Download format dokumen (.xlsx)&nbsp;</li>
                                    <li>Isi dokumen berdasarkan format yang sudah ditentukan</li>
                                    <li>Format dokumen wajib&nbsp;<span class="text-danger"><strong>*</strong></span><strong>.xlsx</strong><span class="text-danger"><strong>*</strong></span></li>
                                    <li><b>PASTIKAN TIDAK ADA IMPORT FILE LEBIH DARI 1 KALI, KARENA AKAN MENYEBABKAN DUPLIKASI AKUN!!</b></li>
                                    <br/>
                                    <a class="btn btn-info pull-right" href={process.env.PUBLIC_URL + '/FORM_IMPORT_SISWA.xlsx'}><li className="fa fa-download"> Download</li></a>
                                </ol>
                            </div>
                        </div>
                    </div>
                    {this.renderModalDownload()}
                    {this.renderModalNewSekolah()}
                    {this.renderModalNewKelasParalel()}
                </div>  
            </div>
        </div>
         );
    }

    fetchSekolah = async (e)=>{
        let data = new FormData();
                
        data.append('idKabupatenKota', this.state.idKabKota);
        data.append('kodeJenjangSekolah', this.state.kodeJenjangSekolah);
        
        const response = await akmApi.post(URL_AKM.FETCH_SEKOLAH_BY_ID_KAB_AND_JENJANG,
            data
        ).catch(function(error){
            this.setState({error})
        })
        
        if(response.data.errorSchema.errorCode == URL_AKM.SUCCESS_ERROR_CODE){
            const data = {value : '', label: 'Pilih Sekolah...', id:'idSekolah', selected: 'selected'}
            this.state.listSekolah.push(data);
            response.data.data.map((val, i)=>{
                const data = {value : val.idSekolah, label: val.namaSekolah, id:'idSekolah'}
                this.state.listSekolah.push(data);
            })
        }
    }

    fetchKelasParalel =  async (e)=>{
        const response = await akmApi.post(URL_AKM.FETCH_KELAS_PARALEL_BY_ID_SEKOLAH_KELAS,
            {
                'idSekolah' : this.state.idSekolah,
                'idKelas' : this.state.idKelas
            }
        ).catch(function(error){
            this.setState({error})
        })
        if(response.data.errorSchema.errorCode == URL_AKM.SUCCESS_ERROR_CODE){
            this.setState({ listKelasParalel:  response.data.data});
        }
    }


    handleSubmitSekolah = async (e)=>{
        e.preventDefault();
        this.setState({ 
            isFetching:true,
            openModalSekolah : false
        });
        
        let data={
            'isPsep' : this.state.isPsep,
            'idProvinsi' : this.state.idProvinsi,
            'idKabupatenKota' : this.state.idKabKota,
            'namaSekolah' : this.state.namaSekolah,
            'kodeJenjangSekolah' : this.state.kodeJenjangSekolah,
            'telponSekolah' : this.state.noTelp,
            'alamatSekolah' : this.state.alamat,
            'emailSekolah' : this.state.email
        }
        const response = await akmApi.post(URL_AKM.ADD_SEKOLAH,
            data 
            ).catch(function(error){
                this.setState({error})
            })

            console.log(response.data)
            
            if(response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
                this.setState({ 
                    keterangan : response.data.data.keterangan,
                    alertShow : true,
                    listSekolah : []
                });
                this.fetchSekolah();
            }else{
                this.setState({ 
                    keterangan : response.data.data.keterangan,
                    alertShow : true 
                });
            }
            this.setState({ isFetching:false  });
    }

    handleSubmitKelasParalel = async (e)=>{
        e.preventDefault();
        this.setState({ 
            isFetching:true,
            openModalKelasParalel : false
        });


        let data={
            'idSekolah' : this.state.idSekolah,
            'idKelas' : this.state.idKelas,
            'namaKelasParalel' : this.state.namaKelasParalel
        }
        const response = await akmApi.post(URL_AKM.ADD_KELAS_PARALEL,data).catch(function(error){
            this.setState({error})
        })

        if(response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE){
            this.setState({ 
                keterangan : response.data.data.keterangan,
                alertShow : true,
                listKelasParalel : []
            });
            this.fetchKelasParalel();
        }else{
            this.setState({ 
                keterangan : response.data.data.keterangan,
                alertShow : true 
            });
        }
        this.setState({ isFetching:false  });
    }
        
    renderModalNewSekolah(){
            const {kodeJenjangSekolahNew, isPsep} = this.state;
            return(
                <Modal 
                show={this.state.openModalSekolah}
                onHide={() => this.setState({ openModalSekolah: false })}
                aria-labelledby="example-custom-modal-styling-title"
                size="lg" backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>New Sekolah</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={this.handleSubmitSekolah}>
                        <Row>
                            <Col sm={3}><label><span className="text-danger">*</span>Nama Sekolah</label></Col>
                            <Col sm={9}>
                                <input className="form-control" onChange={this.handleChangeUniversal}
                                       value={this.state.namaSekolah} name="namaSekolah" required />
                            </Col>
                        </Row>
                        {/* &nbsp;
                        <Row>
                            <Col sm={3}><label><span className="text-danger">*</span>Jenjang Sekolah</label></Col>
                            <Col sm={9}>
                                <select className="form-control" name="kodeJenjangSekolahNew" id="kodeJenjangSekolahNew" 
                                    value={kodeJenjangSekolahNew}
                                    onChange={this.handleChangeUniversal} required >
                                    <option value="" disabled selected>Pilih Kode Jenjang...</option>
                                    <DropdownKodeJenjangSekolah />
                                </select>
                            </Col>
                        </Row> */}
                        &nbsp;
                        <Row>
                            <Col sm={3}><label><span className="text-danger">*</span>Sekolah Psep</label></Col>
                            <Col sm={9}>
                                <select className="form-control" name="isPsep" id="isPsep" 
                                    value={isPsep}
                                    onChange={this.handleChangeUniversal} required >
                                    <option value="" disabled selected>Pilih type PSEP...</option>
                                    <option value="1" >PSEP</option>
                                    <option value="0" >NON PSEP</option>
                                </select>
                            </Col>
                        </Row>
                        &nbsp;
                        <Row>
                            <Col sm={3}><label><span className="text-danger">*</span>No. Telfon</label></Col>
                            <Col sm={9}>
                                <input className="form-control" onChange={this.handleChangeUniversal}
                                       value={this.state.noTelp} name="noTelp" required />
                            </Col>
                        </Row>
                        &nbsp;
                        <Row>
                            <Col sm={3}><label><span className="text-danger">*</span>Email</label></Col>
                            <Col sm={9}>
                                <input className="form-control" onChange={this.handleChangeUniversal}
                                       value={this.state.email} name="email" required />
                            </Col>
                        </Row>
                        &nbsp;
                        <Row>
                            <Col sm={3}><label><span className="text-danger">*</span>Alamat</label></Col>
                            <Col sm={9}>
                                <input className="form-control" onChange={this.handleChangeUniversal}
                                       value={this.state.alamat} name="alamat" required />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <button type="submit" value="Submit" className="btn btn-primary">
                                    <li className="fa fa-save"> save</li>
                                </button>
                            </Col>
                        </Row>

                    </form>
                </Modal.Body>

            </Modal>
        )
    }

    renderModalNewKelasParalel(){
        return(
            <Modal 
                show={this.state.openModalKelasParalel}
                onHide={() => this.setState({ openModalKelasParalel: false })}
                aria-labelledby="example-custom-modal-styling-title"
                size="lg" backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>New Kelas Paralel</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={this.handleSubmitKelasParalel}>
                        <Row>
                            <Col sm={3}><label><span className="text-danger">*</span>Nama Kelas Paralel</label></Col>
                            <Col sm={9}>
                                <input className="form-control" onChange={this.handleChangeUniversal}
                                       value={this.state.namaKelasParalel} name="namaKelasParalel" required />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <button type="submit" value="Submit" className="btn btn-primary">
                                    <li className="fa fa-save"> save</li>
                                </button>
                            </Col>
                        </Row>
                    </form>
                </Modal.Body>

            </Modal>
        )
    }

    renderModalDownload(){
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
        return(
            
            <Modal 
                show={this.state.openModalDownload && !__.isEmpty(this.state.dataSiswa)}
                // onHide={() => this.setState({ })}
                aria-labelledby="example-custom-modal-styling-title"
                size="sm" backdrop="static" keyboard={false}>
                <Modal.Header style={{placeContent: 'center'}}>
                    <Modal.Title>
                        <ExcelFile element={<button className="btn btn-info" onClick={() => this.resetState()}><li className="fa fa-download"> Download Data</li></button>} filename= {this.state.dataSekolah.namaSekolah+"_"+this.state.dataKelasParalel.namaKelasParalel} >
                            <ExcelSheet data={this.state.dataSiswa} name="Username Sekolah">
                                <ExcelColumn label="Nama Siswa" value="namaSiswa"/>
                                <ExcelColumn label="Username" value="usernameSiswa"/>
                                <ExcelColumn label="Password" value="passwordSiswa"/>
                            </ExcelSheet>
                        </ExcelFile>
                    </Modal.Title>
                </Modal.Header>
            </Modal>
        );
    }


    loadAlert = () => {
        const {alertShow,keterangan } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{keterangan}</strong>
            </Alert>
          );
        } 
    }
}
 

const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(ImportSiswa);